"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var useBulkQuery_1 = require("../useBulkQuery/useBulkQuery");
function useQuery(_a) {
    var method = _a.method, options = _a.options, wait = _a.wait;
    var mappedOptions = __assign(__assign({}, options), { args: [options.args] });
    var _b = useBulkQuery_1.default({
        wait: wait,
        method: method,
        options: mappedOptions,
    }), refresh = _b.refresh, results = _b.results;
    var _c = results[0], loading = _c.loading, error = _c.error, response = _c.response;
    return {
        refresh: refresh,
        loading: loading,
        error: error,
        response: response,
    };
}
exports.default = useQuery;
//# sourceMappingURL=useQuery.js.map